<template>
    <div class="description-and-button">
        <el-row :gutter="20">
            <el-col :span="20">
                <el-row
                    v-if="alarm.active"
                    :gutter="20"
                >
                    <el-col :span="6">
                        <span class="alarm-description-bold">
                            {{ getVerbose('alarm_last_trigger') }}
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <span class="alarm-description-bold">
                            {{ alarm.modification_date | moment('YYYY-MM-DD HH:mm') }}
                        </span>
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <span class="alarm-description-bold">
                            {{ getVerbose('alarm_message_title') }}
                        </span>
                    </el-col>
                    <el-col :span="18">
                        {{ alarm.message || getVerbose('alarm_message_empty') }}
                    </el-col>
                </el-row>
                <el-row :gutter="20">
                    <el-col :span="6">
                        <span class="alarm-description-bold">
                            {{ getVerbose('alarm_details_title') }}
                        </span>
                    </el-col>
                    <el-col :span="18">
                        <vue-markdown
                            v-if="alarm.corrective_action_message"
                            :source="alarm.corrective_action_message"
                        ></vue-markdown>
                        <span v-else>{{ getVerbose('alarm_details_empty') }}</span>
                    </el-col>
                </el-row>
            </el-col>
            <el-col :span="4">
                <a
                    v-tooltip.top="getVerbose('alarm_redirection_tooltip')"
                    v-if="alarm.related_url"
                    :href="getCorrectRelatedUrl(alarm.related_url)"
                >
                    <el-button icon="ti ti-link"></el-button>
                </a>

                <a
                    v-tooltip.top="'No related resource'"
                    v-else
                >
                    <el-button
                        icon="ti ti-link"
                        class="no-link"
                        disabled
                    >
                        <i class="ti ti-close"></i>
                    </el-button>
                </a>
            </el-col>
        </el-row>
    </div>
</template>

<script>
import VueMarkdown from 'vue-markdown';
import {mapGetters} from 'vuex';
export default {

    components: { VueMarkdown },

    props: {
        alarm: {
            type: Object,
            required: true,
        }
    },

    computed: {

        ...mapGetters('fundation', [
            'getCorrectRelatedUrl',
            'getVerbose'
        ]),
        setCardClass() {
            return this.alarm.active ? 'box-card-active' : 'box-card-not-active';
        },
    },
};
</script>

<style lang="scss" >
.description-and-button {
    padding: 20px 20px;

    .alarm-description-bold {
        font-weight: bold;
    }

    .alarm-related-url {
      color: #fff;
      text-decoration: underline;

      &:hover{
        color: #fff;
        font-weight: bold;
      }
    }

    .no-link{
        position: relative;

        .ti-close{
            position: absolute;
            left: 19px;
        }
    }
}
</style>




// WEBPACK FOOTER //
// node_modules/fundation-app-vuejs/src/components/pages/alarms/alarmCollapseContent.vue